import { AppState, Auth0Provider } from '@auth0/auth0-react';
import { ReactNode } from 'react';

import { generalConfig } from '~/shared/config/general';

// TODO Move environmental variables to shared/config
const domain = generalConfig.VITE_AUTH0_DOMAIN;
const clientId = generalConfig.VITE_AUTH0_CLIENT_ID;
const redirectUri = generalConfig.VITE_AUTH0_CALLBACK_URL;
const audience = generalConfig.VITE_AUTH0_AUDIENCE;

type Properties = {
  children: ReactNode;
};

export function AppAuth0Provider({ children }: Properties) {
  // This function doesn't use useNavigate because RouterProvider is deeper in the tree
  const onRedirectCallback = (appState?: AppState) => {
    window.history.replaceState(
      {},
      document.title,
      appState?.returnTo || window.location.pathname,
    );
  };

  if (!(domain && clientId && redirectUri)) {
    return null;
  }

  return (
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      authorizationParams={{
        audience,
        redirect_uri: redirectUri,
      }}
      onRedirectCallback={onRedirectCallback}
    >
      {children}
    </Auth0Provider>
  );
}
